import React, { useCallback } from "react";

export const RoutingContext = React.createContext({});

const redirectKey = "app-redirect-pathname";

export function RoutingContextProvider({ children }) {
  const getRedirect = useCallback(() => {
    return window.sessionStorage.getItem(redirectKey);
  }, []);

  const setRedirect = useCallback(redirect => {
    if (redirect) {
      window.sessionStorage.setItem(redirectKey, redirect);
    } else {
      window.sessionStorage.removeItem(redirectKey);
    }
  }, []);
  return <RoutingContext.Provider value={{ getRedirect, setRedirect }}>{children}</RoutingContext.Provider>;
}
